import React from 'react';
import { Platform, Pressable, View, type ViewStyle } from 'react-native';
import { Text } from './Text';
import { makeStyles, radius } from './theme';

const useStyles = makeStyles((c) => ({
  card: { backgroundColor: c.surface, borderRadius: radius.lg, borderWidth: 1, borderColor: c.border, overflow: 'hidden' },
  head: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 8, paddingHorizontal: 16, paddingTop: 14, paddingBottom: 10, flexWrap: 'wrap' },
  body: { padding: 16 },
  bodyAfterHead: { paddingTop: 4 },
}));

export interface CardProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  /** no body padding (tables, lists) */
  flush?: boolean;
  onPress?: () => void;
  style?: ViewStyle;
  testID?: string;
}

export function Card({ title, subtitle, actions, children, flush, onPress, style, testID }: CardProps) {
  const s = useStyles();
  const content = (
    <>
      {(title || actions) && (
        <View style={s.head}>
          <View style={{ flexShrink: 1 }}>
            {!!title && <Text variant="title">{title}</Text>}
            {!!subtitle && <Text variant="small">{subtitle}</Text>}
          </View>
          {actions ? <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>{actions}</View> : null}
        </View>
      )}
      {children !== undefined && <View style={flush ? undefined : [s.body, title || actions ? s.bodyAfterHead : null]}>{children}</View>}
    </>
  );
  if (onPress)
    return (
      <Pressable testID={testID} onPress={onPress} accessibilityRole={Platform.OS === 'web' ? undefined : 'button'} focusable style={({ pressed }) => [s.card, pressed && { opacity: 0.85 }, style]}>
        {content}
      </Pressable>
    );
  return (
    <View testID={testID} style={[s.card, style]}>
      {content}
    </View>
  );
}
